export const getAnchorElementFromEvent = (evt: React.MouseEvent<Element, MouseEvent>) => {
  const anchor = [evt.target, evt.currentTarget].find(
    (targ) => (targ as HTMLElement).nodeName === 'A',
  );

  return anchor && (anchor as HTMLAnchorElement);
};
